<template>
  <div class="pc-preview-container mt-5">
    <div class="email-preview">
      <div class="flex-row just-between mb-4">
        <img
          src="@shared/assets/img/logo/black-logo.png"
          class="logo"
          alt="SmartAC.com"
        >
       <div class="logo-label">
        CHANGE IS IN THE AIR®
       </div>
      </div>
      <div class="email-inner">
        <h4 class="text-center" style="font-size: 26px;">
          Welcome to Smart Maintenance®
        </h4>
        <h5 class="mb-8 sac__font-15 text-center">from {{currentCorporation.corporationName}} + SmartAC.com!</h5>
        <table cellpadding="0" cellspacing="0" border="0" 
            class="we-email-image"
            style="margin: 0; padding: 0; background-image: url('https://smac-images.s3.us-west-2.amazonaws.com/email/technician-bg.png');background-size: cover;background-repeat: no-repeat;box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.4);border-radius:8px;">
            <tr>
                <td align="center" width="25%" class="email-image">
                    <img v-if="logoPreview" :src="logoPreview" alt="Logo" style="width:90px;object-fit: contain;" />
                </td>
                <td style="padding-left:24px;">
                    <img src="https://smac-images.s3-us-west-2.amazonaws.com/email/welcome-ac.png" alt="SmartAC.com" style="width:120px;object-fit: contain;" />
                </td>
            </tr>
        </table>
      </div>
    </div>
    <div class="pc-preview-title">
      Member Welcome Email
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeEmailPreview',
  props: {
    primaryColor: String,
    logoPreview: String,
    currentCorporation: Object,
  },
  computed: {
    backgroundColor() {
      return {
        display: 'flex',
        'justify-content': 'center',
        'background-color': this.primaryColor,
      };
    },
    imageContainerStyle() {
      return {
        position: 'absolute',
        top: '12vh',
      };
    },
    imageStyle() {
      return {
        width: '20vh',
        height: '10vh',
        'object-fit': 'contain',
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.pc-preview-container {
  margin-right: 12px;
  position: relative;
  width: 100%;
  .email-preview {
    margin-top: 10px;
    background-color: #F3F3F3;
    border-radius: 8px;
    padding:  40px 30px 0px 30px;
    width: 100%;
    .email-inner{
      width: 100%;
      padding:  35px 25px 25px 25px;

      margin-top: 25px;
      border-top-left-radius: 17px;
      border-top-right-radius: 17px;
      background-color: white;
      .email-image{
        background-color: v-bind(primaryColor);
        border-top-left-radius:8px;
        border-bottom-left-radius:8px;
      }
      .we-email-image {
          //width:630px;
          width: 100%;
          height:300px;
      }
    }
  }

  .pc-home-img {
    height: 520px;
  }

  .pc-preview-background {
    border-radius: 50px;
  }

  .pc-logo-container {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .pc-logo-img {
      width: 160px;
      height: 160px;
      object-fit: contain;
    }
  }
  .logo {
    width: 184px;
    object-fit: contain;
    @media (max-width: 420px) {
      width: 120px;
    }
    @media (max-width: 320px) {
      width: 100px;
    }
  }
  .logo-label{
    font-size: 18.5px;
    font-weight: 700;
  }
  .pc-preview-title {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
